import React from 'react'
import './home.css'
import Images from '../../data/Images'
import SocialContact from '../../Common/SocialContact/SocialContact'
import Seperator from '../../Common/Seperator/Seperator'


const Home = () => {

  return (
    <div className='header'>
      <div className="h-left">
        <div className="content">
          <div data-aos="fade-up" className="c-titles"><Seperator/> <span><h2>D</h2></span>
          <span><h2>h</h2></span>
          <span><h2>r</h2></span>
          <span><h2>u</h2></span>
          <span><h2>v</h2></span>
          <span className='space'><h2></h2></span>
          <span><h2>A</h2></span>
          <span><h2>s</h2></span>
          <span><h2>t</h2></span>
          <span><h2>h</h2></span> </div>
          <div data-aos="fade-up" className='h-title'>Work From <br/> Your Heart.</div>
          <p data-aos="fade-up">I design and develop services for customers of all sizes,<br/> specializing in
          creating stylish logos and UI, modern <br/> websites, games and online stores.</p>
          <a data-aos="fade-up" href='#contact' className='button' >Let's Talk</a>
        </div>
        <div data-aos="fade-up" className="h-social">
          <h4 className='h-social-title'>Check out my</h4>
          <SocialContact/>
        </div>
      </div>
      <div data-aos="fade-up" className="h-right">
        <img src={Images.Code} alt="code" />
      </div>
    </div>
  )
}

export default Home
